import React from 'react';
import styled from 'styled-components';

const Edges = (props) => <Container {...props}>{props.children}</Container>;

Edges.defaultProps = {
    size: 'lg'
};

const Container = styled('div' as any)`
    width: 95%;
    margin: 0 auto;
    ${(props) => props.size === 'none' && 'width: 100%;'}
    ${(props) => props.size === 'sm' && 'max-width: 600px;'}
    ${(props) => props.size === 'md' && 'max-width: 960px;'}
    ${(props) => props.size === 'lg' && 'max-width: 1400px;'}
`;

export default Edges;
